export { AbsencesInbox } from "./absences-inbox";
